$(document).on('click', '[data-product-add-to-cart]', function (e) {
    const productUniqueId = $(this).data('productAddToCart'),
        activeProduct = $('[data-product-unique-id="' + productUniqueId + '"]'),
        hasFeatures = activeProduct.data('productHasFeature'),
        hasVariations = activeProduct.data('productHasVariation'),
        hasOrderInputs = activeProduct.data('productHasOrderInputs'),
        url = activeProduct.data('productUrl'),
        isPopupEnabled = activeProduct.data('productIsPopupEnabled');

    if(hasFeatures || hasVariations || hasOrderInputs) {
        if (isPopupEnabled && window.innerWidth > 768){

            App.prototype.showProduct(productUniqueId, url);

        }else{

            location.href = url;

        }

    } else {
        let queryStringAppend = '';

        if(url){
            const queryString = url.split('?');

            if (queryString.length > 1){
                queryStringAppend = '?' + queryString[1];
            }
        }

        App.prototype.addProductToCart(productUniqueId, 1, queryStringAppend);
    }
});

function setNullValuesFromParent(product) {

    if (product.parent === undefined || product.parent === null) return;

    if (product.price === null) {
        product.price = product.parent.price;
    }

    if (product.normal_price === null) {
        product.normal_price = product.parent.normal_price;
    }

    if (product.discounted_price === null) {
        product.discounted_price = product.parent.discounted_price;
    }

    if (product.images.length === 0) {
        product.images = product.parent.images;
    }

    if ($.trim(product.description) === '') {
        product.description = product.parent.description;
    }
}

$(document).on('click', '[data-show-product]', function (e) {
    const productUniqueId = $(this).data('showProduct'),
        activeProduct = $('[data-product-unique-id="' + productUniqueId + '"]'),
        url = activeProduct.data('productUrl'),
        isPopupEnabled = activeProduct.data('productIsPopupEnabled');

    if (isPopupEnabled && window.innerWidth > 768) {

        e.preventDefault();

        App.prototype.showProduct(productUniqueId, url);

    }
});

App.prototype.showProduct = function (product_unique_id, url = null){

    let queryStringAppend = '';

    if(url){
        const queryString = url.split('?');

        if (queryString.length > 1){
            queryStringAppend = '?' + queryString[1];
        }
    }

    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'products/' + product_unique_id + queryStringAppend,
        dataType: "json",
        success: function (response) {

            setNullValuesFromParent(response);

            const
                featureSelectionModal = $('#featureSelectionModal'),
                riodeProductModal = $('#riodeProductModal'),
                productDetailModal = $('#productDetailModal');

            if (featureSelectionModal.length){

                if(!featureSelectionModal.hasClass('show')){
                    var obj = {Page: null, Url: url};
                    history.pushState(obj, obj.Page, obj.Url);
                }

                featureSelectionModal.modal('show');
                featureSelectionModal.find('.quantity-input').val(1);
                featureSelectionModal.find('.count').text(1);
                App.prototype.buildProductFeaturesModal(response, product_unique_id);

            }

            if (productDetailModal.length){

                if(!productDetailModal.hasClass('show')){
                    var obj = {Page: null, Url: url};
                    history.pushState(obj, obj.Page, obj.Url);
                }

                productDetailModal.modal('show');
                App.prototype.buildProductDetailModal(response, product_unique_id);

            }

            if (riodeProductModal.length){
                if ($('.mfp-wrap.mfp-product.mfp-ready').length){

                    App.prototype.riodeBuildProductDetailModal(response);

                }else{

                    Riode.popup({
                        items: {
                            src: '#riodeProductModal',
                            type: 'inline'
                        },
                        callbacks: {
                            open: function () {
                                App.prototype.riodeBuildProductDetailModal(response);
                                Riode.quantityInput($('#riodeProductModal').find('.quantity'))
                            },
                            close: function (){
                                if (history.state) {
                                    history.back();
                                }
                            },
                        }
                    }, 'quickview');

                }

            }

        }
    });
};

$(document).on('click', '.product-box .increase', function () {
    const _el = $(this);
    var activeProduct = $(this).closest('.product-box');
    var productHash = activeProduct.data('product_hash');

    _el.prop('disabled', true);

    App.prototype.toggleDisabledBasketFields(true);
    $.ajax({
        type: 'POST',
        url: App.prototype.apiAddress + 'basket/'+productHash+'/increase',
        dataType: "json",
        success: function (response) {
            App.prototype.notificationSuccess('Ürün sepette eklendi.');
            App.prototype.buildCart(response);
            App.prototype.reloadBasketPage(response);

            var pagebutton = document.getElementById("selfclick");

            if(pagebutton){
                pagebutton.click();
            }
        },
        error: function (response) {

            App.prototype.notificationError(response.responseJSON.error);

        },
        complete: function (){

            App.prototype.toggleDisabledBasketFields(false);

            _el.prop('disabled', false);
            // $('[data-installment-manager]').trigger('cartUpdated');

        },
    });
});

$(document).on('click', '.product-box .decrease', function () {
    const _el = $(this);
    var activeProduct = $(this).closest('.product-box');
    var productHash = activeProduct.data('product_hash');
    _el.prop('disabled', true);

    App.prototype.removeProductFromCart(productHash, () => {
        _el.prop('disabled', false);
    });
});

$("body").on("keyup",".product-box .count",debounce(function(){
    var activeProduct = $(this).closest('.product-box');
    var productHash = activeProduct.data('product_hash');
    let count = $(this).val() || 1;
    count = count.toString().replace(/[^0-9]/g, '');
    count = parseInt(count);
    $(this).val(count);
    App.prototype.updateProductQuantity(productHash, count);
}, 1000));

App.prototype.updateProductQuantity = function (productHash, quantity) {
    App.prototype.toggleDisabledBasketFields(true);
    $.ajax({
        type: 'POST',
        url: App.prototype.apiAddress + 'basket/'+productHash+'/update',
        dataType: "json",
        data: {
            quantity: quantity
        },
        success: function (response) {
            App.prototype.notificationSuccess('Ürün adedi güncellendi.');
            App.prototype.buildCart(response);
            App.prototype.reloadBasketPage(response);
        },
        error: function (response) {
            App.prototype.notificationError(response.responseJSON.error);
        },
        complete: function (){
            App.prototype.toggleDisabledBasketFields(false);
            $('[data-installment-manager]').trigger('cartUpdated');
        },
    });
}

function debounce(func, delay) {
    let timeoutId;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}
